var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.7 39.7",
    style: {
      enableBackground: "new 0 0 39.7 39.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "history"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "history_2",
    d: "M19.9,36.3c-4.2,0-7.9-1.4-11-4.2C5.7,29.3,4,25.8,3.5,21.6h3.8c0.4,3.2,1.8,5.8,4.2,7.9 s5.2,3.1,8.4,3.1c3.6,0,6.6-1.2,9.1-3.7s3.7-5.5,3.7-9.1s-1.2-6.6-3.7-9.1S23.5,7,19.9,7c-2.1,0-4.1,0.5-5.9,1.5s-3.4,2.3-4.6,4h5 v3.7h-11v-11h3.7v4.3c1.6-2,3.5-3.5,5.7-4.5c2.2-1.2,4.6-1.7,7.1-1.7c2.3,0,4.4,0.4,6.4,1.3s3.7,2,5.2,3.5 c1.5,1.5,2.7,3.2,3.5,5.2c0.9,2,1.3,4.1,1.3,6.4s-0.4,4.4-1.3,6.4c-0.9,2-2,3.7-3.5,5.2c-1.5,1.5-3.2,2.7-5.2,3.5 C24.3,35.9,22.2,36.3,19.9,36.3z M25,27.5l-7-7v-9.9h3.7V19l5.9,5.9L25,27.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistory);
export default __webpack_public_path__ + "static/media/icon_history.8ef0114f6714af43c9251ffad7584884.svg";
export { ForwardRef as ReactComponent };